import { requestServiceOnRollOffData } from "constants-lib/seo/requestServiceOnRollOffData"
import { addJSONLDToHead, removeElement } from "./jsonLD.js"

export const getRequestServiceOnRollOff = (schemaData) => {
  const data = schemaData.map((item) => ({
    "@type": `Question`,
    name: item.Question,
    acceptedAnswer: {
      "@type": `Answer`,
      text: item.Answer,
    },
  }))
  return data
}

/* Add Request Service on Roll Off JSON LD if needed, otherwise make sure it does not exist in Head. */
export const addRequestServiceOnRollOff = () => {
  if (
    window.location.href.includes(
      `/us/en/support/faqs/how-do-i-request-service-on-a-roll-off-dumpster`,
    ) &&
    document.getElementById(`requestServiceOnRollOff`) === null
  ) {
    const script = requestServiceOnRollOffJSONLD()
    addJSONLDToHead(script, `requestServiceOnRollOff`)
  } else {
    removeElement(`requestServiceOnRollOff`)
  }
}

// JSON LD template for Request Service on Roll Off
const requestServiceOnRollOffJSONLD = () => {
  const requestServiceTemplate = {
    "@context": `http://schema.org`,
    "@type": `FAQPage`,
    mainEntity: getRequestServiceOnRollOff(requestServiceOnRollOffData),
  }
  return requestServiceTemplate
}
